import { STRINGS } from '../../constants';
import filterEmptyParams from '../../utils/filters';
import apiCaller from '../http';
import URLS from '../urls';

const updateServiceCartItem = async (
  visitId,
  itemId,
  value,
  setError,
  setModalVisible,
  refreshVisitDetail,
  logoutHandler,
) => {
  const { name, quantity, price } = value;
  const convertedPrice = price.replace(',', '.');
  const payload = { name, quantity, price: convertedPrice };
  await apiCaller
    .put(`${URLS.SERVICE_CART_UPDATE_ITEM}${visitId}/${itemId}/`, filterEmptyParams(payload))
    .then((response) => {
      if (response.data !== undefined) {
        setError(null);
        setModalVisible(false);
        refreshVisitDetail();
      } else {
        setError(STRINGS.common.error404Text);
      }
    })
    .catch((e) => {
      if (e.message === STRINGS.common.errorMissingCredentials) {
        logoutHandler();
      }
      if (e.message === STRINGS.common.error400Template) {
        setError(STRINGS.common.error400Text);
      }
    });
};

export default updateServiceCartItem;
